import {Dom, Event, Loc, Type} from 'main.core';
import {Dialog, Item} from 'ui.entity-selector';

import './entity-selector-tree.css';

;(function () {
  if (typeof Dialog !== 'undefined') {
    Dialog.prototype.tree = false;
    const oldSetOptions = Dialog.prototype.setOptions;
    Dialog.prototype.setOptions = function (dialogOptions) {
      oldSetOptions.apply(this, [dialogOptions]);
      const options = Type.isPlainObject(dialogOptions) ? dialogOptions : {};
      if (Type.isBoolean(options.tree)) {
        this.tree = options.tree;
      }
    };

    Dialog.prototype.isTree = function () {
      return this.tree;
    };
  }

  if (typeof Item !== 'undefined') {
    let proto = new Item({id: 0, entityId: 'example'}).createNode().__proto__;

    /** START Устанавливаем класс selected для родительских элементов */
    const oldGetOuterContainer = proto.getOuterContainer;
    proto.getOuterContainer = function getOuterContainer() {
      if (!this.getDialog().isTree()) {
        return oldGetOuterContainer.apply(this);
      }

      return this.cache.remember('outer-container', () => {
        let className = '';
        if (this.hasChildren() || this.isDynamic()) {
          className += ' ui-selector-item-box-has-children';
          if (this.getDepthLevel() >= this.getTab().getItemMaxDepth()) {
            className += ' ui-selector-item-box-max-depth';
          }
        } /* else */
        if (this.getItem().isSelected()) {
          className += ' ui-selector-item-box-selected';
        }
        if (this.isOpen()) {
          className += ' ui-selector-item-box-open';
        }
        const div = document.createElement('div');
        div.className = `ui-selector-item-box${className}`;
        div.appendChild(this.getContainer());
        div.appendChild(this.getChildrenContainer());
        return div;
      });
    }
    /* END */

    /** START Переопределяем создание контейнера элемента и вешаем клик на стрелочку для открытия/закрытия */
    const oldGetContainer = proto.getContainer;
    proto.getContainer = function getContainer() {
      if (!this.getDialog().isTree()) {
        return oldGetContainer.apply(this);
      }

      return this.cache.remember('container', () => {
        const div = document.createElement('div');
        div.className = 'ui-selector-item';
        Event.bind(div, 'click', this.handleClick.bind(this));
        Event.bind(div, 'mouseenter', this.handleMouseEnter.bind(this));
        Event.bind(div, 'mouseleave', this.handleMouseLeave.bind(this));
        div.appendChild(this.getAvatarContainer());
        div.appendChild(this.getTitlesContainer());
        const indicatorDiv = this.getIndicatorContainer();
        Event.bind(indicatorDiv, 'click', this.handleClickArrow.bind(this));
        div.appendChild(indicatorDiv);
        if (this.hasChildren() && this.getDialog().isMultiple()) {
          div.appendChild(this.getLinkContainer());
        }
        return div;
      });
    }

    proto.handleClickArrow = function handleClickArrow(event) {
      if (this.hasChildren() || this.isDynamic()) {
        if (this.isOpen()) {
          this.collapse();
        } else {
          this.expand();
        }
        event.stopPropagation();
      }
    }
    /* END */

    /** START При клике по родительскому элементу его можно выбрать */
    const oldClick = proto.click;
    proto.click = function click() {
      if (!this.getDialog().isTree()) {
        return oldClick.apply(this);
      }

      if (this.getItem().isSelected()) {
        if (this.getItem().isDeselectable()) {
          this.getItem().deselect();
        }
        if (this.getDialog().shouldHideOnDeselect()) {
          this.getDialog().hide();
        }
      } else {
        this.getItem().select();
        if (this.getDialog().shouldClearSearchOnSelect()) {
          this.getDialog().clearSearch();
        }
        if (this.getDialog().shouldHideOnSelect()) {
          this.getDialog().hide();
        }
      }
      this.getDialog().focusSearch();
    }

    const oldSelect = proto.select;
    proto.select = function select() {
      if (!this.getDialog().isTree()) {
        return oldSelect.apply(this);
      }

      Dom.addClass(this.getOuterContainer(), 'ui-selector-item-box-selected');
    }

    const oldDeselect = proto.deselect;
    proto.deselect = function deselect() {
      if (!this.getDialog().isTree()) {
        return oldDeselect.apply(this);
      }

      Dom.removeClass(this.getOuterContainer(), 'ui-selector-item-box-selected');
    }
    /* END */

    /** START Логика выбора всех дочерних элементов */
    proto.selectAll = function selectAll() {
      if (!this.getDialog().isMultiple()) {
        return;
      }

      function recursive(itemNode) {
        if (!itemNode) {
          return;
        }

        itemNode.getItem().select();

        if (itemNode.hasChildren() && itemNode.getDialog().isMultiple()) {
          for (let subitemNode of itemNode.getChildren().items) {
            recursive(subitemNode)
          }
        }
      }

      recursive(this);

      this.setLinkTitle(Loc.getMessage('UI_SELECTOR_CANCEL_ALL'));
      this.getLinkTitleNode().renderTo(this.getLinkTextContainer());
    };

    proto.deselectAll = function deselectAll() {
      if (!this.getDialog().isMultiple()) {
        return;
      }

      function recursive(itemNode) {
        if (!itemNode) {
          return;
        }

        itemNode.getItem().deselect();

        if (itemNode.hasChildren() && itemNode.getDialog().isMultiple()) {
          for (let subitemNode of itemNode.getChildren().items) {
            recursive(subitemNode)
          }
        }
      }

      recursive(this);

      this.setLinkTitle(Loc.getMessage('UI_SELECTOR_SELECT_ALL'));
      this.getLinkTitleNode().renderTo(this.getLinkTextContainer());
    };

    proto.isAllSelected = function isAllSelected() {
      if (!this.getDialog().isMultiple()) {
        return false;
      }

      function recursive(itemNode) {
        return itemNode.getItem().isSelected() && (!itemNode.hasChildren() || itemNode.getChildren().items.every(recursive));
      }

      return recursive(this);
    };

    const oldGetLinkContainer = proto.getLinkContainer;
    proto.getLinkContainer = function getLinkContainer() {
      if (!this.getDialog().isTree()) {
        return oldGetLinkContainer.apply(this);
      }

      return this.cache.remember('link', () => {
        const anchor = document.createElement('a');
        anchor.className = 'ui-selector-item-link';
        anchor.href = this.getLink();
        anchor.title = '';
        anchor.appendChild(this.getLinkTextContainer());
        Event.bind(anchor, 'click', this.handleLinkClick.bind(this));
        return anchor;
      });
    };

    const oldGetLink = proto.getLink;
    proto.getLink = function getLink() {
      if (!this.getDialog().isTree()) {
        return oldGetLink.apply(this);
      }

      return 'javascript:void(0);';
    };

    const oldGetLinkTitle = proto.getLinkTitle;
    proto.getLinkTitle = function getLinkTitle() {
      if (!this.getDialog().isTree()) {
        return oldGetLinkTitle.apply(this);
      }

      return Loc.getMessage(this.isAllSelected() ? 'UI_SELECTOR_CANCEL_ALL' : 'UI_SELECTOR_SELECT_ALL');
    };

    const oldShowLink = proto.showLink;
    proto.showLink = function showLink() {
      if (this.getDialog().isTree() && this.hasChildren() && this.getLinkTitleNode().getText() !== this.getLinkTitle()) {
        this.setLinkTitle(this.getLinkTitle());
        this.getLinkTitleNode().renderTo(this.getLinkTextContainer());
      }

      return oldShowLink.apply(this);
    };

    const oldGetLinkTitleNode = proto.getLinkTitleNode;
    proto.getLinkTitleNode = function getLinkTitleNode() {
      if (this.getDialog().isTree() && this.linkTitle === null && this.hasChildren()) {
        this.setLinkTitle(this.getLinkTitle());
      }

      return oldGetLinkTitleNode.apply(this);
    };

    const oldHandleLinkClick = proto.handleLinkClick;
    proto.handleLinkClick = function handleLinkClick(event) {
      if (!this.getDialog().isTree()) {
        return oldHandleLinkClick.apply(this, [event]);
      }

      event.stopPropagation();

      this.isAllSelected() ? this.deselectAll() : this.selectAll();
    };
    /* END */
  }
})();
